// Route overrides for the "next" interface template, keyed by classic route
// name. The router swaps in these components when the template is active;
// every route not listed here keeps its classic page.
export const nextRouteOverrides = {
  appearance: {
    component: () => import('./views/AppearancePage.vue')
  }
}
